import getNative from "./_getNative.js";
var defineProperty = function() {
  try {
    var func = getNative(Object, "defineProperty");
    return func({}, "", {}), func;
  } catch {
  }
}();
export {
  defineProperty as default
};
//# sourceMappingURL=_defineProperty.js.map
